import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './InfrastructureSection.css';
import { NBSP } from 'shared/constants/symbols';

interface IInfrastructureSectionProps {
  mapFragment: React.ReactNode;
  categories: React.ReactNode;
  distance?: number;
}

export const InfrastructureSection: React.FC<IInfrastructureSectionProps> = ({ mapFragment, categories, distance }) => {
  return (
    <div>
      {mapFragment}
      {distance && (
        <div className={styles['distance']}>
          <UIText1 as="p">
            Показываем объекты в {distance} км от{NBSP}дома
          </UIText1>
        </div>
      )}
      <div className={styles['categories']}>{categories}</div>
    </div>
  );
};
